import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import ConfirmButton from '../ConfirmButton';

const DenyInvitationButton = ({
  invitation,
  handleDeny,
  size="small",
  ...props
}) => (
  <ConfirmButton
    size={size}
    working={invitation.deleting}
    onClick={handleDeny}
    message={
      <FormattedMessage id="invitation.confirmation.denyInvitation" />
    }
    {...props}
  >
    <FormattedMessage id='invitation.button.denyInvitation' />
  </ConfirmButton>
)

DenyInvitationButton.propTypes = {
  invitation: PropTypes.object.isRequired,
  handleDeny: PropTypes.func.isRequired,
}

export default DenyInvitationButton;


// WEBPACK FOOTER //
// ./src/components/invitations/DenyInvitationButton.js